<div>
  @for (button of buttonValues(); track button.value) {
  <button
    (click)="setValue(button.value)"
    [ngClass]="{ active: inputControl.value === button.value }"
  >
    {{ button.displayValue }}
  </button>
  }
</div>
